import "datejs";

export const createColumn = (
  field,
  headerName,
  width,
  type = "string",
  renderCell = null,

) => {

  const dateFieldPatterns = [
    'date',
    'datum',
    'time',
    'created',
    'updated',
    'timestamp'
  ];
  
  const isDateField = dateFieldPatterns.some(pattern => 
    field.toLowerCase().includes(pattern.toLowerCase())
  );


  const defaultDateFormatter = ({ value }) => {
    try {
      if (!value) return '';
      const date = new Date(value);
      return date.toString("dd.MM.yyyy HH:mm");
    } catch (e) {
      console.error(`Error formatting date for field ${field}:`, e);
      return value; // Return original value if formatting fails
    }
  };

  const booleanRenderer = (params) =>
    params.value ? (
      <span style={{ color: "green", fontSize: "1.2rem" }}>✓</span>
    ) : (
      <span style={{ color: "red", fontSize: "1.2rem" }}>✗</span>
    );

  return {
    field: field,
    headerName: headerName,
    width: width,
    type: type,
    headerAlign: "center",
    align: "center",
    headerClassName: "super-app-theme--header",

    ...(renderCell && { renderCell }),
    ...(['isCanceled', 'isPaid', 'isAGift', 'isVerified', 'isActive', 'isDeleted'].includes(field) && {
      renderCell: booleanRenderer
    }),
    ...(isDateField && !renderCell && {
      renderCell: defaultDateFormatter
    })
  };
};